import { useEffect, useState } from 'react'
import { useSearchPatient } from '../../../../../hooks/NewCase/useSearchPatient'
import { postPatient, updatePatient } from '../../../../../hooks/NewCase/usePostPatient'
import { SessionExpired } from '../../../../SessionExpired'
import { useRequiered } from '../../../../../hooks/NewCase/Requiered/useRequiered'
import { provinceOptions } from '../../../../../const/provincias'
import {
  Container,
  TitleWrapper,
  NewUserTitle,
  DniTitle,
  FillSectionWrapper,
  FillSection,
  SeparatorFillSection,
  InputWrapper,
  Label,
  InputTemplate,
  SelectTemplate,
  LabelContainer,
  TwinInputContainer,
  TwinInputWrapper,
  SmallInput,
  RadioWrapper,
  RadioOptions,
  RadioInput,
  Option,
  RadioLabel,
  ButtonsWrapper,
  TittleContainer,
  Button,
  ButtonSpinner,
  MultipleInputContainer,
  SmallInputWrapper,
  SmallInputWithIconWrapper,
  InputForIcon,
  InputTemplateExtended
} from './styles'

export function PhaseOne ({ backStep, nextPhase }) {
  const { patient, patientData, search, error } = useSearchPatient()
  const [noSocialSecurity, setNoSocialSecurity] = useState(true)
  const [loading, setLoading] = useState(false)
  const { isValid, setPatientData, dataError, checkRequired, buttonAvailable, errorMessages } = useRequiered('PhaseOne')
  const [data, setData] = useState({
    dni: patient ? patient.dni : '',
    genero: patient ? patient.genero : '',
    nombre: '',
    apellido: '',
    fechaNacimiento: '',
    telefono: '',
    calle: '',
    numero: '',
    piso: '',
    departamento: '',
    email: '',
    localidad: '',
    provincia: '',
    tipoSeguridadSocial: 'Ninguna',
    codigoAfiliado: ''
  })

  const optAntecedentes = [
    'Si', 'No', 'No sabe'
  ]

  const savePatient = async () => {
    try {
      checkRequired(data, noSocialSecurity, false, true)
    } catch (error) {
    }
  }

  function formatearFechaNacimiento (fechaNacimiento) {
    const fecha = new Date(fechaNacimiento)
    const formattedDate = fecha.toISOString().split('T')[0]
    return formattedDate
  }

  useEffect(() => {
    if (!isValid) return
    const next = async () => {
      setLoading(true)
      try {
        if (patientData) {
          await updatePatient(data, patientData.id)
          sessionStorage.setItem('_patient', JSON.stringify(patientData))
        } else {
          await postPatient(data)
          sessionStorage.setItem('_patient', JSON.stringify(data))
        }
        nextPhase()
      } catch (error) {
      } finally {
        setLoading(false)
      }
    }
    next()
  }, [isValid])

  useEffect(() => {
    const fetchData = async () => {
      await search()
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (patientData) {
      setPatientData(patientData)
      setData(patientData)
      const isNoSocialSecurity = patientData && patientData.tipoSeguridadSocial === 'Ninguna'
      setNoSocialSecurity(isNoSocialSecurity)
      checkRequired(patientData, isNoSocialSecurity, false, false, null, patientData)
    }
  }, [patientData])

  const changeHandler = event => {
    if (event.target.name === 'tipoSeguridadSocial') {
      event.target.value === 'Ninguna' ? setNoSocialSecurity(true) : setNoSocialSecurity(false)
    }
    updateData(event.target.name, event.target.value)
  }

  const blurHandler = event => {
    const fieldName = event.target.name
    const fieldValue = event.target.value

    let currentNoSocialSecurity = noSocialSecurity
    if (fieldName === 'tipoSeguridadSocial') {
      currentNoSocialSecurity = fieldValue === 'Ninguna'
      setNoSocialSecurity(currentNoSocialSecurity)
    }

    setData(prevData => {
      const newData = { ...prevData, [fieldName]: fieldValue }
      checkRequired(newData, currentNoSocialSecurity, false, false, fieldName)
      return newData
    })
  }

  const updateData = (name, value) => {
    setData(prevData => {
      const newData = { ...prevData, [name]: value }
      checkRequired(newData, noSocialSecurity, false, false)
      return newData
    })
  }

  useEffect(() => {
    updateData('tipoSeguridadSocial', data.tipoSeguridadSocial)
  }, [noSocialSecurity])

  const renderFieldError = (field) => {
    const hasError = errorMessages && typeof errorMessages === 'object' && errorMessages[field] && errorMessages[field] !== ''
    return (
      <Label
        error
        style={{ visibility: hasError ? 'visible' : 'hidden' }}
      >
        {hasError ? errorMessages[field] : 'Error'}
      </Label>
    )
  }

  return (
    <Container>
      <SessionExpired />
      <TitleWrapper>
        <TittleContainer>
          <NewUserTitle> {error && error ? 'Nuevo Paciente' : 'Modificar Paciente'} </NewUserTitle>
          <DniTitle> DNI {patient && patient.dni} </DniTitle>
        </TittleContainer>
      </TitleWrapper>

      <FillSectionWrapper>
        <FillSection>
          <TwinInputContainer>
            <TwinInputWrapper>
              <LabelContainer>
                <Label> Nombre </Label>
              </LabelContainer>
              <SmallInput error={dataError && dataError.nombre} onChange={changeHandler} onBlur={blurHandler} name='nombre' defaultValue={patientData ? patientData.nombre : ''} />
              {renderFieldError('nombre')}
            </TwinInputWrapper>

            <TwinInputWrapper>
              <LabelContainer>
                <Label> Apellido </Label>
              </LabelContainer>
              <SmallInput error={dataError && dataError.apellido} onChange={changeHandler} onBlur={blurHandler} name='apellido' defaultValue={patientData ? patientData.apellido : ''} />
              {renderFieldError('apellido')}
            </TwinInputWrapper>
          </TwinInputContainer>

          <TwinInputContainer>
            <TwinInputWrapper>
              <Label> Fecha de nacimiento </Label>
              <InputTemplate error={dataError && dataError.fechaNacimiento} onChange={changeHandler} onBlur={blurHandler} name='fechaNacimiento' type='date' defaultValue={patientData ? formatearFechaNacimiento(patientData.fechaNacimiento) : ''} />
              {renderFieldError('fechaNacimiento')}
            </TwinInputWrapper>
            <TwinInputWrapper>
              <Label> Telefono </Label>
              <SmallInput error={dataError && dataError.telefono} onChange={changeHandler} onBlur={blurHandler} name='telefono' defaultValue={patientData ? patientData.telefono : ''} />
              {renderFieldError('telefono')}
            </TwinInputWrapper>
          </TwinInputContainer>

          <InputWrapper>
            <Label> Correo electrónico </Label>
            <InputTemplate error={dataError && dataError.email} onChange={changeHandler} onBlur={blurHandler} name='email' defaultValue={patientData ? patientData.email : ''} />
            {renderFieldError('email')}
          </InputWrapper>
        </FillSection>

        <SeparatorFillSection />

        <FillSection>
          <TwinInputContainer>
            <TwinInputWrapper>
              <LabelContainer>
                <Label> Calle </Label>
              </LabelContainer>
              <SmallInput error={dataError && dataError.calle} onChange={changeHandler} onBlur={blurHandler} name='calle' defaultValue={patientData ? patientData.calle : ''} />
              {renderFieldError('calle')}
            </TwinInputWrapper>

            <TwinInputWrapper>
              <LabelContainer>
                <Label> Número </Label>
              </LabelContainer>
              <SmallInput error={dataError && dataError.numero} onChange={changeHandler} onBlur={blurHandler} name='numero' defaultValue={patientData ? patientData.numero : ''} />
              {renderFieldError('numero')}
            </TwinInputWrapper>
          </TwinInputContainer>

          <TwinInputContainer>
            <TwinInputWrapper>
              <Label>
                <Label> Piso </Label>
                <Label attenuated> (Opcional) </Label>
              </Label>
              <SmallInput onChange={changeHandler} onBlur={blurHandler} name='piso' defaultValue={patientData ? patientData.piso : ''} type='number' />
              {renderFieldError('piso')}
            </TwinInputWrapper>

            <TwinInputWrapper>
              <Label>
                <Label> Departamento </Label>
                <Label attenuated> (Opcional) </Label>
              </Label>
              <SmallInput onChange={changeHandler} onBlur={blurHandler} name='departamento' defaultValue={patientData ? patientData.departamento : ''} />
              {renderFieldError('departamento')}
            </TwinInputWrapper>
          </TwinInputContainer>

          <TwinInputContainer>
            <TwinInputWrapper>
              <Label>Provincia</Label>
              <SelectTemplate name='provincia' value={data.provincia} onChange={changeHandler} onBlur={blurHandler}>
                <Option value='' disabled>Seleccionar</Option>
                {provinceOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </SelectTemplate>
              {renderFieldError('provincia')}
            </TwinInputWrapper>
            <TwinInputWrapper>
              <Label> Localidad </Label>
              <SmallInput error={dataError && dataError.localidad} onChange={changeHandler} onBlur={blurHandler} name='localidad' defaultValue={patientData ? patientData.localidad : ''} />
              {renderFieldError('localidad')}
            </TwinInputWrapper>
          </TwinInputContainer>

        </FillSection>

        <SeparatorFillSection />

        <FillSection>
          <RadioWrapper>
            <LabelContainer>
              <Label> Seguridad social </Label>
            </LabelContainer>
            <RadioOptions>
              <RadioLabel>
                <RadioInput onChange={changeHandler} onBlur={blurHandler} name='tipoSeguridadSocial' checked={data.tipoSeguridadSocial === 'Obra Social'} type='radio' value='Obra Social' />
                Obra Social
              </RadioLabel>

              <RadioLabel>
                <RadioInput onChange={changeHandler} onBlur={blurHandler} name='tipoSeguridadSocial' checked={data.tipoSeguridadSocial === 'Prepaga'} type='radio' value='Prepaga' />
                Prepaga
              </RadioLabel>

              <RadioLabel>
                <RadioInput onChange={changeHandler} onBlur={blurHandler} name='tipoSeguridadSocial' checked={noSocialSecurity || (data.tipoSeguridadSocial === 'Ninguna')} type='radio' value='Ninguna' />
                Ninguna
              </RadioLabel>
            </RadioOptions>
            {renderFieldError('tipoSeguridadSocial')}
          </RadioWrapper>

          {!noSocialSecurity && <InputWrapper>
            <LabelContainer>
              <Label> Código de afiliado </Label>
            </LabelContainer>
            <InputTemplate error={dataError && dataError.codigoAfiliado} onChange={changeHandler} onBlur={blurHandler} name='codigoAfiliado' defaultValue={patientData ? patientData.codigoAfiliado : ''} />
            {renderFieldError('codigoAfiliado')}
          </InputWrapper>}
        </FillSection>
      </FillSectionWrapper>
      {errorMessages && typeof errorMessages === 'string' && errorMessages !== '' && (
        <Label error>{errorMessages}</Label>
      )}
      <ButtonsWrapper>
        <Button onClick={backStep}> Volver </Button>
        <Button highlighted disabled={!buttonAvailable || loading} onClick={savePatient}>
          {loading ? <ButtonSpinner /> : 'Siguiente'}
        </Button>
      </ButtonsWrapper>
    </Container>
  )
}

export default PhaseOne
